import { Directive } from '@angular/core';
import { InputComponent } from './../base-components/input/input/input.component';

@Directive({
    selector: '[showPassword]'
})
export class ShowPasswordDirective {
    private _shown: boolean = false;

    constructor(private element: InputComponent) {
        const span = document.createElement('span');
        span.classList.add('fa');
        span.classList.add('fa-eye');
        span.style.cssText = 'position: absolute; right: 5px; top: 22px; z-index: 999';
        span.addEventListener('click', () => {
            this.togglePassword(span);
        });

        setTimeout(() => {
            const parentElement = this.element.inputControl.nativeElement.parentNode;
            parentElement.appendChild(span);
        }, 100)
    }

    private togglePassword(span: HTMLElement) {
        this._shown = !this._shown;
        if (this._shown) {
            this.element.inputControl.nativeElement.setAttribute('type', 'text');
            span.classList.remove('fa-eye');
            span.classList.add('fa-eye-slash');
        } else {
            this.element.inputControl.nativeElement.setAttribute('type', 'password');
            span.classList.remove('fa-eye-slash');
            span.classList.add('fa-eye');
        }
    }
}
